export default "__VITE_ASSET__Dl_NtFW1__"